<template>
  <WujieVue width="100%" height="100%" :name="flowUrl" :url="flowUrl" :plugins="plugins" />
</template>

<script>
import { getAiAgentFlowUrl, objectToQueryString } from '@/utils/wujieConfig';

export default {
  data() {
    return {
      flowUrl: getAiAgentFlowUrl(),
      plugins: [
        {
          patchElementHook(element, iframeWindow) {
            if (element.nodeName === 'STYLE') {
              element.insertAdjacentElement = function (_position, ele) {
                iframeWindow.document.head.appendChild(ele);
              };
            }
          },
        },
      ],
    };
  },
  computed: {},
  async created() {
    console.log('%c Line:29 🍰 this.flowUrl', 'color:#465975', this.flowUrl);
    const params = objectToQueryString(this.$route.query);
    if (params) {
      this.flowUrl += objectToQueryString(this.$route.query);
    }
    console.log('%c Line:44 🥔 this.flowUrl', 'color:#ffdd4d', this.flowUrl);
  },

  methods: {},
};
</script>

<style lang="scss" scoped></style>
